import { Component, inject } from '@angular/core';
import { ModalService } from 'src/utils/modal.service';
import { ModalComponent } from 'src/ui/components/modal/modal.component';

@Component({
  selector: 'app-global-modal',
  standalone: true,
  imports: [ModalComponent],
  templateUrl: './global-modal.component.html',
})
export class GlobalModalComponent {
  protected readonly modalService = inject(ModalService);
}
